import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getWorkflowCase,
  listWorkflowCases,
  updatePreviousApprovalNote,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 「前回承認時の申し送り」(= 差戻し後に保持される承認メモ) を編集する
 * mutation hook (workflow-fix-approval-ux Design Note Decision #3、spec
 * AC-WFW-007c/d)。onSuccess で detail + list query を invalidate する。
 */
export function useUpdatePreviousApprovalNote(
  caseId: string,
): InvalidatingMutationResultFor<typeof updatePreviousApprovalNote> {
  return useInvalidatingMutation(updatePreviousApprovalNote, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
